import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-tasks-status-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './tasks-status-page.component.html',
  styleUrl: './tasks-status-page.component.css'
})
export class TasksStatusPageComponent {

}
